import WorkoutDayPanel from './WorkoutDayPanel';

export default WorkoutDayPanel;
